<template>
  <v-app>
    <div id="app">
<!--  todo: hide the toolbar stuff if authenticated from app (however we want to do that)    -->
      <v-toolbar id="nav" v-if="!noHeader && loggedIn" color="white">
        <img @click="goHome" style="cursor: pointer;" src="./assets/itovi_blue.png" height="45" alt="itovi"/>
          <v-spacer />
        <v-toolbar-items>
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="nav-menu-button itoviGrayMid--text"
                        color="white"
                        v-bind="attrs"
                        v-on="on"
                        depressed
                    >
                        <img src="./assets/account_circle-24px.svg" height="32" class="mr-2"/>
                        {{ user && user.first_name || "" }} {{ user && user.last_name || "" }}
                        <v-icon class="ml-2" color="itoviGrayLight" style="font-size: 14px" >fas fa-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile
                        v-for="(item, index) in menuItems"
                        :key="index"
                        @click="item.onClick"
                    >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar-items>
      </v-toolbar>

      <template v-if="$route.matched.length">
        <router-view></router-view>
      </template>

      <template v-else>
<!--        <p>You are logged {{ loggedIn ? 'in' : 'out' }}</p>-->
      </template>

<!--      <div id="nav">-->
<!--        <router-link to="/">Home</router-link> |-->
<!--        <router-link to="/about">About</router-link>-->
<!--      </div>-->
<!--      <router-view/>-->
    </div>
  </v-app>
</template>

<style lang="scss">
    @import "./assets/css/app.scss";
    @font-face {
      font-family: "Barlow";
      src: local("Barlow-Bold"),
        url(./assets/fonts/Barlow-Bold.otf);
      font-weight: 700;
    }
    @font-face {
      font-family: "Barlow";
      src: local("Barlow-SemiBold"),
      url(./assets/fonts/Barlow-SemiBold.otf);
      font-weight: 600;
    }
    @font-face {
      font-family: "Barlow";
      src: local("Barlow-Medium"),
      url(./assets/fonts/Barlow-Medium.otf);
      font-weight: 500;
    }
    @font-face {
      font-family: "Barlow";
      src: local("Barlow-Regular"),
      url(./assets/fonts/Barlow-Regular.otf);
      font-weight: 400;
    }
</style>

<script>
  import auth from './auth'
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    data () {
      return {
        noHeader: false,
        loggedIn: auth.loggedIn(),
        showLoginBtn: true,
        showLogoutBtn: false,
        menuItems: [
          { title: 'DNA', onClick: () => this.goToDna() },
          { title: 'Logout', onClick: () => this.logout()  }
        ],
        user: this.$store.state.user
      }
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['user']);
    },
    created () {
      this.configureAppBar()
    },
    updated () {
      this.configureAppBar()
    },
    methods: {
      goHome() {
        this.$router.replace('/')
      },
      logout () {
        auth.logout();
        this.$router.replace('/login');
        // refresh the appbar if we are already on the home page
        if (this.$router.currentRoute.name === 'home') this.configureAppBar()
      },
      login () {
        this.$router.replace('/login')
      },
      async configureAppBar () {
        this.loggedIn = auth.loggedIn();
        this.showLoginBtn = !this.loggedIn && this.$router.currentRoute.name !== 'login';
        this.showLogoutBtn = this.loggedIn;
        this.noHeader = this.$route.query.hasOwnProperty('apptoken') && this.loggedIn;
      },
      goToDna() {
        let dnaUrl = 'https://dna.itovi.com/';
        if (process.env.VUE_APP_MODE === "development" || process.env.VUE_APP_MODE === "staging" ) dnaUrl = 'http://staging.dna.itovi.com';
        window.open(dnaUrl, "_self");
      }
    }
  }
</script>
